import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TournamentForm } from '../sections/tournament_action';

const StyledContent = styled('div')(({ theme }) => ({
    width: '60vw',
    minWidth: 320,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(4, 0),
}));

export default function TournamentAction() {
    const { id } = useParams();
    const isEditMode = !!id;

    return (
        <>
            <Helmet>
                <title> {!isEditMode ? 'Create' : 'Edit'} Tournament | Trooper</title>
            </Helmet>
            <Container>
                <Typography variant="h4" gutterBottom>
                    {!isEditMode ? 'Create' : 'Edit'} Tournament
                </Typography>

                <StyledContent>
                    <TournamentForm edit={isEditMode} />
                </StyledContent>
            </Container>
        </>
    );
}
